import React from 'react';
import { Tag } from 'antd';

const CONFIDENCE_CONFIG = {
  high: { color: 'green', label: 'Tin cậy cao' },
  medium: { color: 'gold', label: 'Tin cậy trung bình' },
  low: { color: 'orange', label: 'Suy luận thấp' },
};

const SUGGESTION_CONFIG = {
  keep: { color: 'blue', label: 'Giữ lại' },
  merge: { color: 'purple', label: 'Đề xuất gộp' },
  drop: { color: 'red', label: 'Đề xuất bỏ' },
};

export default function InferenceConfidenceBadge({ value, suggestionType, compact = false }) {
  const confidence = CONFIDENCE_CONFIG[value] || CONFIDENCE_CONFIG.medium;
  const suggestion = suggestionType ? SUGGESTION_CONFIG[suggestionType] : null;
  const tagStyle = compact ? { marginInlineEnd: 0, borderRadius: 999, fontWeight: 600 } : { borderRadius: 999, fontWeight: 600 };

  return (
    <span style={{ display: 'inline-flex', gap: 8, flexWrap: 'wrap', justifyContent: compact ? 'flex-end' : 'flex-start' }}>
      <Tag color={confidence.color} style={tagStyle}>{confidence.label}</Tag>
      {suggestion ? <Tag color={suggestion.color} style={tagStyle}>{suggestion.label}</Tag> : null}
    </span>
  );
}
